import { useEffect, useState } from "react";
import { navSections } from "@/mocks/chigua";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const today = new Date();
  const dateStr = `${today.getFullYear()}年${today.getMonth() + 1}月${today.getDate()}日`;

  return (
    <header className="sticky top-0 z-40 border-b border-foreground-200/60 bg-background-50/90 backdrop-blur-md">
      {/* utility strip */}
      <div className="border-b border-background-200 bg-background-100/80 text-foreground-600">
        <div className="container-page flex items-center justify-between py-1.5 text-xs">
          <p className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-calendar-line text-accent-600"></i>
            {dateStr} · 今日热榜已更新
          </p>
          <p className="hidden items-center gap-1.5 whitespace-nowrap sm:flex">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-accent-400 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-accent-500"></span>
            </span>
            每日 09:00 准时出刊
          </p>
        </div>
      </div>

      <nav className="container-page flex items-center justify-between py-3 md:py-4">
        {/* brand */}
        <a href="#top" className="group flex items-center gap-2" aria-label="吃瓜日报 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-quill-pen-fill text-xl"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-lg font-black tracking-tight text-foreground-950 md:text-xl">
              吃瓜<span className="text-primary-600">日报</span>
            </span>
            <span className="text-[10px] font-medium tracking-wide text-foreground-500">DAILY MELON</span>
          </span>
        </a>

        {/* desktop nav */}
        <div className="hidden items-center gap-1 md:flex">
          {navSections.map((n) => (
            <a
              key={n.id}
              href={`#${n.id}`}
              className="rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition hover:bg-background-100 hover:text-primary-700"
            >
              {n.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#newsletter"
            className="hidden items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-600 md:inline-flex"
          >
            <i className="ri-mail-send-line"></i>
            订阅每日热榜
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-foreground-200 text-foreground-800 transition hover:bg-background-100 md:hidden"
            aria-label="打开菜单"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
          </button>
        </div>
      </nav>

      {/* mobile menu */}
      <div className={`overflow-hidden transition-all duration-300 md:hidden ${scrolled ? "" : ""}`}>
        {open && (
          <div className="border-t border-background-200 px-4 pb-4">
            <div className="grid grid-cols-2 gap-1 pt-3">
              {navSections.map((n) => (
                <a
                  key={n.id}
                  href={`#${n.id}`}
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-2 rounded-md px-3 py-2.5 text-sm font-medium text-foreground-700 transition hover:bg-background-100 hover:text-primary-700"
                >
                  <i className={`${n.icon} text-accent-600`}></i>
                  {n.label}
                </a>
              ))}
            </div>
            <a
              href="#newsletter"
              onClick={() => setOpen(false)}
              className="mt-2 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50"
            >
              <i className="ri-mail-send-line"></i>
              订阅每日热榜
            </a>
          </div>
        )}
      </div>
    </header>
  );
}